module.exports = __webpack_public_path__ + "img/WhatsApp.svg?v=1748265296610";